import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hijunior/components/Container/Container';
import Row from '@Theme/hijunior/components/Row/Row';
import Column from '@Theme/hijunior/components/Column/Column';
import Text from '@Theme/hijunior/components/Text/Text';
import Icon from '@Theme/hijunior/components/Icon/Icon';

import * as styles from './ContactInfo.module.scss';

const propTypes = {
  /**
   * Items data - heading and description
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string
    })
  ),

  /**
   * Additional classname
   */
  classname: PropTypes.string
};

const Contact = ({
  items,
  classname
}) => {
  if (!items) {
    return false;
  }

  return (
    <section className={`${styles.root} ${classname || ''}`}>
      <Container>
        <Row>
          {items.map(({
            heading,
            description
          }, index) => (
            <Column
              key={index}
              xs={4}
              md={{
                col: 3,
                offset: index ? 0 : 3
              }}
              classname={styles.rootCol}>
              <Icon name={index ? 'emailIcon' : 'addressIcon'}
                size={{
                  width: 56,
                  height: 44
                }}
                classname={styles.rootIcon}/>
              <Text as='div' contents={heading} classname={styles.rootTitle}/>
              <Text
                as='div'
                contents={description}
                classname={styles.rootDescription}/>
            </Column>
          ))}
        </Row>
      </Container>
    </section>
  );
};

Contact.propTypes = propTypes;

export default Contact;
